



























import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component, Watch} from "vue-property-decorator";
import {getGroups} from "@/modules/account/service";
import {LIMIT_PAGE_DEFAULT, PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {PaginationMeta} from "@/interfaces/common";
import {debounce} from "lodash";

const columns = [
    {
        title: "STT",
        dataIndex: "stt",
        key: "rowGuid",
        width: 50,
        ellipsis: true
    },
    {
        title: "Tài khoản",
        dataIndex: "account.username",
        key: "username",
        width: 100,
        ellipsis: true
    },
    {
        title: "Họ tên",
        dataIndex: "fullName",
        key: "fullName",
        width: 150,
        ellipsis: true
    },
    {
        title: "Số điện thoại",
        dataIndex: "phoneNumber",
        key: "phoneNumber",
        width: 150,
        ellipsis: true
    },
    {
        title: "Email",
        dataIndex: "email",
        key: "email",
        width: 150,
        ellipsis: true
    }
]

const params = {
    page: 1,
    limit: LIMIT_PAGE_DEFAULT,
    search: undefined
}
@Component({
    name: "Member"
})
export default class extends mixins(CommonMixin) {
    members = [] as any;
    columns = [...columns];
    params = { ...params } as any;
    meta: PaginationMeta = new PaginationMeta();

    created() {
        this.getMembers(this.params);
    }

    async getMembers(params: any) {
        try {
            const { data } = await getGroups(params);
            this.members = data.datas?.map((data: any, index: number) => ({ ...data, stt: index + 1, children: undefined }));
            this.meta = data.meta;
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
        }
    }

    get pagination() {
        return {
            current: this.meta.page,
            pageSize: this.meta.limit,
            total: this.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} khách hàng`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        this.getMembers({...this.params, page: pagination.current, limit: pagination.pageSize});
    }

    @Watch("params", { deep: true })
    onChangeParams(val: any) {
        this.handleChangeParams(val, this);
    }

    handleChangeParams = debounce((val: any, vm) => {
        vm.getMembers({...val, page: 1});
    }, 500)
}
